import React from "react";
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import {
    Grid,
    Card,
    CardHeader,
    CardContent,
    CircularProgress,
    Button,
    TableCell,
    TableRow,
    Fab,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableBody,
    TablePagination,
    MenuItem,
    Select,
    FormControl,
    InputLabel
} from "@material-ui/core";
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { getSpecificClients } from "views/clients/api/apiClients";
import { getEmployees, deleteEmployee, getEmployeeAssets, getEmployeeById, exportToDocx, exportToPdf } from "../api/apiEmployee";
import CreateOrUpdateEmployee from "./CreateOrUpdateEmployee";
import ConfirmationDialog from "common/components/ConfirmationDialog";
import SelectClient from "common/components/custom/SelectClient";
import DetailsEmployeeDialog from "./DetailsEmployeeDialog";

class Employees extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            specificsClients: [],
            isOpen: false,
            selectedClient: null,
            employees: [],
            employeeToEdit: null,
            employeeToDelete: null,
            dialogOpen: false,
            detailsModal: false,
            isLoading: true,
            activePage: 0,
            totalElements: 0,
            rowsPerPage: 25,
            employeeAssets: [],
            displayEmployee: null,
            employeeId: null,
            active: true
        };
    }

    async componentDidMount() {
        this.getSpecificClients()
    }

    handleChangePage = (event, newPage) => {
        this.setState({ activePage: newPage }, () => this.getEmployees(newPage, this.state.selectedClient.id))
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value, 10), activePage: 0 }, () => this.getEmployees(this.state.activePage, this.state.selectedClient.id))
    };

    handleChangeActive = (event) => {
        this.setState({ active: event.target.value }, () => this.getEmployees(0, this.state.selectedClient.id));
    }

    getSpecificClients = () => {
        getSpecificClients().then((response) => {
            let selectedClient = response.data.data.length > 0 ? response.data.data[0] : null
            this.setState({ specificsClients: response.data.data, selectedClient: selectedClient, isLoading: false }, selectedClient ? this.getEmployees(0, selectedClient.id) : null);
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getEmployees = (page, selectedClient) => {
        getEmployees({ params: { page: page, size: this.state.rowsPerPage, isActive: this.state.active === '' ? null : this.state.active } }, selectedClient).then((response) => {
            this.setState({
                employees: response.data.data.content,
                totalElements: response.data.data.totalElements,
                isLoading: false
            });
            if (page > 0 && response.data.data.content.length === 0) {
                this.setState({ activePage: page }, () => this.getEmployees(page - 1, this.state.selectedClient));
            }
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getEmployeeById = (id) => {
        getEmployeeById(id).then(response => {
            this.setState({ employeeToEdit: response.data.data, isOpen: true });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("error_get_employee_by_id"), { variant: 'error' });
        });
    }

    getEmployeeAssets = (id) => {
        this.setState({ employeeId: id })
        getEmployeeAssets(id/* , { params: { year: null } } */).then((response) => {
            this.setState({
                employeeAssets: response.data.data,
                detailsModal: true
            });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("error_get_employee_by_id"), { variant: 'error' });
        });
    }

    deleteEmployee = () => {
        let { employeeToDelete } = this.state
        deleteEmployee(employeeToDelete.id).then(response => {
            this.props.enqueueSnackbar(this.props.t("delete_message_employee", { firstName: this.state.employeeToDelete.firstName, lastName: this.state.employeeToDelete.lastName }), { variant: 'success' });
            this.setState({ dialogOpen: false, employeeToDelete: null, rowsPerPage: this.state.rowsPerPage }, () => this.getEmployees(0, this.state.selectedClient.id));
        }).catch(error => {
            console.log(error)
            this.props.enqueueSnackbar(this.props.t("error_delete_employee"), { variant: 'error' });
        });
    }

    handleContentDisposition = (response) => {
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const contentDisposition = response.headers["content-disposition"];
        let fileName = contentDisposition.split("filename=")[1];
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
    }

    exportToDocx = () => {
        exportToDocx({
            headers: {
                'Content-Type': 'application/octet-stream',
                'Accept': 'application/octet-stream',
                'Access-Control-Expose-Headers': 'Content-Disposition'
            },
            responseType: 'blob',
            params: {
                employeeId: this.state.employeeId
            }
        }).then(response => {
            this.handleContentDisposition(response)
            this.closeEmployeeAssetDialog()
            this.props.enqueueSnackbar(this.props.t("success_export_to_document"), { variant: 'success' });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("error_export_to_document"), { variant: 'error' });
        });
    }

    exportToPdf = () => {
        exportToPdf({
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/pdf',
                'Access-Control-Expose-Headers': 'Content-Disposition'
            },
            responseType: 'blob',
            params: {
                employeeId: this.state.employeeId
            }
        }).then(response => {
            this.handleContentDisposition(response)
            this.closeEmployeeAssetDialog()
            this.props.enqueueSnackbar(this.props.t("success_export_to_document"), { variant: 'success' });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("error_export_to_document"), { variant: 'error' });
        });
    }

    handleChange = (client) => {
        if (client !== null) {
            this.setState({ selectedClient: client }, () => this.getEmployees(0, client.id))
        } else {
            this.setState({ selectedClient: null })
        }
    }

    closeDialog = () => {
        this.setState({ isOpen: false, employeeToEdit: null });
    }

    closeEmployeeAssetDialog = () => {
        this.setState({ detailsModal: false, employeeAssets: [], displayEmployee: null });
    }

    render() {

        let { employees, isOpen, specificsClients, isLoading, selectedClient, employeeToEdit, employeeToDelete, dialogOpen, detailsModal, displayEmployee } = this.state;

        if (isLoading) {
            return (
                <div className="loading-position">
                    <CircularProgress className="spinner" color="primary" />
                </div>
            )
        }

        let employeesList;
        let recordsNotFound;
        if (employees && employees.length > 0) {
            employeesList = employees.map((employee, index) => {
                return <TableRow key={index}>
                    <TableCell>{employee.firstName}</TableCell>
                    <TableCell>{employee.lastName}</TableCell>
                    <TableCell>{employee.email}</TableCell>
                    <TableCell>{employee.businessUnit}</TableCell>
                    <TableCell>{employee.isInternal ? <CheckIcon fontSize="small" className="fa fa-plus-circle" style={{ color: 'green' }} /> : <CloseIcon fontSize="small" className="fa fa-plus-circle" style={{ color: 'red' }} />}</TableCell>
                    <TableCell>{employee.isActive ? <CheckIcon fontSize="small" className="fa fa-plus-circle" style={{ color: 'green' }} /> : <CloseIcon fontSize="small" className="fa fa-plus-circle" style={{ color: 'red' }} />}</TableCell>
                    <TableCell>
                        <Fab title={this.props.t("edit")} onClick={() => this.getEmployeeById(employee.id)} size="small" style={{ marginRight: 10 }} color="secondary" aria-label="edit">
                            <EditIcon />
                        </Fab>
                        <Fab title={this.props.t("delete")} onClick={() => this.setState({ employeeToDelete: employee, dialogOpen: true })} size="small" style={{ marginRight: 10 }} color="inherit" aria-label="delete">
                            <DeleteIcon />
                        </Fab>
                        <Fab title={this.props.t("details")} onClick={() => {
                            this.getEmployeeAssets(employee.id);
                            this.setState({ displayEmployee: employee });
                        }
                        } size="small" style={{ marginRight: 10 }} color="primary" aria-label="delete">
                            <MoreVertIcon />
                        </Fab>
                    </TableCell>
                </TableRow >
            });
        } else {
            recordsNotFound = <TableRow>
                <TableCell align="center" colSpan={6}>
                    <p>{this.props.t("no_records_found")}</p>
                </TableCell>
            </TableRow>
        }

        return <Grid container direction="row" spacing={2}>
            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                <CardHeader
                    title={this.props.t("employees")}
                    action={
                        selectedClient !== null && <Button variant="contained" color="secondary" aria-label="edit" onClick={() => this.setState({ clientToEdit: null, isOpen: true })} style={{ top: '4px' }}>
                            {this.props.t("add_new_employee")}
                        </Button>
                    } />
                <Card>
                    <CardContent>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={3} sm={3} md={3} lg={3} xl={3}>
                                <Grid container direction="row" spacing={2}>
                                    <SelectClient
                                        specificsClients={specificsClients}
                                        selectedClient={selectedClient}
                                        handleChange={this.handleChange}
                                    />
                                </Grid>
                            </Grid>

                            <Grid item container direction="column" xs={1} sm={1} md={1} lg={1} xl={1}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container>
                                        <FormControl variant="outlined" fullWidth>
                                            <InputLabel id="demo-simple-select-outlined-label" margin="dense">{this.props.t("active")}</InputLabel>
                                            <Select
                                                style={{ height: '40px' }}
                                                labelId="demo-simple-select-outlined-label"
                                                name="active"
                                                value={this.state.active}
                                                onChange={this.handleChangeActive}
                                                label={this.props.t("active")}
                                                margin="dense">
                                                <MenuItem value={''}>{this.props.t("all")}</MenuItem>
                                                <MenuItem value={true}>{<CheckIcon style={{ color: 'green' }} />}</MenuItem>
                                                <MenuItem value={false}>{<CloseIcon style={{ color: 'red' }} />}</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        {selectedClient !== null && <><Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container>
                                        <TableContainer component={Paper}>
                                            <Table aria-label="simple table" size="small" style={{ tableLayout: 'fixed' }}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell component="th" scope="row" width="15%">{this.props.t("first_name")}</TableCell>
                                                        <TableCell component="th" scope="row" width="15%">{this.props.t("last_name")}</TableCell>
                                                        <TableCell component="th" scope="row" width="20%">{this.props.t("email")}</TableCell>
                                                        <TableCell component="th" scope="row" width="15%">{this.props.t("business_unit")}</TableCell>
                                                        <TableCell component="th" scope="row" width="10%">{this.props.t("internal_employee")}</TableCell>
                                                        <TableCell component="th" scope="row" width="10%">{this.props.t("active")}</TableCell>
                                                        <TableCell component="th" scope="row" width="15%"></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {employeesList}
                                                    {recordsNotFound}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                            <TablePagination
                                component="div"
                                count={this.state.totalElements}
                                rowsPerPageOptions={[10, 25, 50, 100]}
                                page={this.state.activePage}
                                onPageChange={this.handleChangePage}
                                rowsPerPage={this.state.rowsPerPage}
                                onRowsPerPageChange={this.handleChangeRowsPerPage}
                                backIconButtonText={this.props.t("previous_page")}
                                labelRowsPerPage={this.props.t("rows_per_page")}
                                nextIconButtonText={this.props.t("next_page")}
                            /></>}
                    </CardContent>
                </Card>
            </Grid>
            <CreateOrUpdateEmployee
                isOpen={isOpen}
                onClose={this.closeDialog}
                selectedClient={selectedClient}
                employeeToEdit={employeeToEdit ? employeeToEdit : null}
                getEmployees={() => this.getEmployees(this.state.activePage, selectedClient.id)}
            />
            <DetailsEmployeeDialog
                isOpen={detailsModal}
                employee={displayEmployee}
                exportToDocx={this.exportToDocx}
                exportToPdf={this.exportToPdf}
                onClose={this.closeEmployeeAssetDialog}
                employeeAssets={this.state.employeeAssets}
            />
            {
                employeeToDelete && <ConfirmationDialog
                    isOpen={dialogOpen}
                    title={this.props.t("delete_employee")}
                    message={this.props.t("delete_employee_dialog_message", { firstName: employeeToDelete.firstName, lastName: employeeToDelete.lastName })}
                    onClose={() => this.setState({ dialogOpen: false })}
                    onConfirm={() => this.setState({ dialogOpen: false }, () => this.deleteEmployee())}
                    closeButtonTitle={this.props.t("close")}
                    confirmButtonTitle={this.props.t("delete")}
                />
            }
        </Grid >
    }
}

export default withSnackbar(withTranslation()(Employees))